// React
import React, { useEffect, useState, useContext } from "react";
// React
// CSS
import styles from "./SlidesBanner.module.css";
// CSS
// Models
import { I_HomePageSlides } from "../../Models/interfaces";
// Models
// Services
import { getHomePageSlides_Service } from "../../Services/Home/get/getHomePageSlides_Service";
// Services
// Modules
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "./SwiperBannerManager.css";
import { Pagination, Mousewheel, Keyboard, Autoplay } from "swiper";
// Modules
// Contexts
import { UserTokenContext } from "../../Contexts/userToken";
// Contexts
// Skeleton
import Skeleton, { SkeletonTheme } from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { toast } from "react-toastify";
// Skeleton

const SlidesBanner: React.FC<{ slides: I_HomePageSlides[], isPending: boolean }> = (props) => {

  return (
    <div
      className={`${styles.homePageSlidesBannerContainer} flex items-center justify-center relative pb-0`}
    >
      {props.isPending ? (
        <>
          <SkeletonTheme
            baseColor="rgba(126, 58, 229 , 0.1)"
            highlightColor="rgba(126, 0, 229, 0.6)"
          >
            <p>
              <Skeleton
                count={1}
                width={"calc(100vw - 2rem)"}
                height={"120px"}
                style={{ marginTop: "1rem" }}
              />
            </p>
          </SkeletonTheme>
        </>
      ) : (
        <>
          <Swiper
            spaceBetween={12}
            slidesPerView={1}
            className="mt-2"
            direction="horizontal"
            centeredSlides={true}
            initialSlide={0}
            pagination={{
              clickable: true,
              el: `.swiperBannerPagination`,
            }}
            speed={500}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            loop
            modules={[Pagination, Mousewheel, Keyboard, Autoplay]}
          >
            {props.slides.map((item) => (
              <SwiperSlide
                key={item.url}
                className="flex items-center justify-center rounded-2xl"
              >
                <img
                  src={item.url.replace(/(http[^\s])/i, "https:").replace("::", ":")}
                  className="w-full h-full rounded-2xl object-cover"
                  alt={item.title + " Banner !"}
                  style={{ width: "100%", height: "15vh" }}
                />
              </SwiperSlide>
            ))}
          </Swiper>
          <div className={`swiperBannerPagination`}></div>
        </>
      )}
    </div>
  );
};

export default SlidesBanner;
